import { message } from 'antd';
import { useEffect, useState } from 'react';
import axios from '../../../util/Api';

export const useTraining = () => {
  const [loading, setLoading] = useState(true);
  const [training, setTraining] = useState([]);

  useEffect(() => {
    getTrainingStats();
  }, []);

  const getTrainingStats = () => {
    setLoading(true);
    const url = `stats/training`;
    axios.get(url).then(resp => {
      setTraining(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data training");
    });
  }

  return { loading, training };
}

export const useTrainingBar = () => {
  const [loadingBar, setLoadingBar] = useState(true);
  const [trainingBar, setTrainingBar] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const url = `stats/company-training`;
    axios.get(url).then(resp => {
      setTrainingBar(resp.data);
      setLoadingBar(false);
    }).catch(err => {
      message.error("Gagal memuat data training bar");
    });
  }

  return { loadingBar, trainingBar };
}

export const useTrainingChart = () => {
  const [loading, setLoading] = useState(true);
  const [training, setTraining] = useState([]);

  useEffect(() => {
    getTrainingStats();
  }, []);

  const getTrainingStats = () => {
    setLoading(true);
    const url = `stats/training-title`;
    axios.get(url).then(resp => {
      setTraining(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data training");
    });
  }

  return { loading, training };
}

export const useViolation = () => {
  const [loading, setLoading] = useState(true);
  const [violation, setViolation] = useState([]);

  useEffect(() => {
    getViolationStats();
  }, []);

  const getViolationStats = () => {
    setLoading(true);
    const url = `stats/violation`;
    axios.get(url).then(resp => {
      setViolation(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data pelanggaran");
    });
  }

  return { loading, violation };
}

export const useViolationBar = () => {
  const [loadingBar, setLoadingBar] = useState(true);
  const [violationBar, setViolationBar] = useState([]);

  useEffect(() => {
    fetchViolationBar();
  }, []);

  const fetchViolationBar = () => {
    const url = `stats/company-violation`;
    axios.get(url).then(resp => {
      setViolationBar(resp.data);
      setLoadingBar(false);
    }).catch(err => {
      message.error("Gagal memuat data manpower");
    });
  }

  return { loadingBar, violationBar };
}

export const useManpower = () => {
  const [loading, setLoading] = useState(true);
  const [manpower, setManpower] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/manpower`;
    axios.get(url).then(resp => {
      setManpower(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data manpower");
    });
  }

  return { loading, manpower };
}

export const useManpowerBar = () => {
  const [loadingBar, setLoadingBar] = useState(true);
  const [manpowerBar, setManpowerBar] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const url = `stats/company-passport`;
    axios.get(url).then(resp => {
      setManpowerBar(resp.data);
      setLoadingBar(false);
    }).catch(err => {
      message.error("Gagal memuat data manpower bar");
    });
  }

  return { loadingBar, manpowerBar };
}

export const usePassport = () => {
  const [loading, setLoading] = useState(true);
  const [passport, setPassport] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/passport`;
    axios.get(url).then(resp => {
      setPassport(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data total user");
    });
  }

  return { loading, passport };
}

export const useManhours = () => {
  const [loading, setLoading] = useState(true);
  const [manhours, setManhours] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/manhours`;
    axios.get(url).then(resp => {
      setManhours(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data manhours");
    });
  }

  return { loading, manhours };
}

export const useFitness = () => {
  const [loading, setLoading] = useState(true);
  const [fitness, setFitness] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/fitness`;
    axios.get(url).then(resp => {
      setFitness(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data fitness");
    });
  }

  return { loading, fitness };
}

export const useFitnessBar = () => {
  const [loading, setLoading] = useState(true);
  const [fitnessBar, setFitnessBar] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/fitness-bar`;
    axios.get(url).then(resp => {
      setFitnessBar(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data fitness bar");
    });
  }

  return { loading, fitnessBar };
}

export const useRealtimeTap = () => {
  const [loading, setLoading] = useState(true);
  const [taps, setTaps] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/realtime-tap`;
    axios.get(url).then(resp => {
      setTaps(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data realtime tap");
    });
  }

  return { loading, taps };
}

export const usePassportCategory = () => {
  const [loading, setLoading] = useState(true);
  const [passportCategory, setPassportCategory] = useState([]);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = () => {
    setLoading(true);
    const url = `stats/passport-category`;
    axios.get(url).then(resp => {
      setPassportCategory(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data realtime tap");
    });
  }

  return { loading, passportCategory };
}